module.exports = __webpack_public_path__ + "static/img/ly.a70f092c.png";